// ----------------------------------------------------------------------

export default function Skeleton(theme?:React.CSSProperties | any) {
  return {
    MuiSkeleton: {
      defaultProps: {
        animation: 'wave',
      },

      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.neutral,
        },
      },
    },
  };
}
